import { render, staticRenderFns } from "./calls-list.vue?vue&type=template&id=bab962da&scoped=true"
import script from "./calls-list.vue?vue&type=script&lang=js"
export * from "./calls-list.vue?vue&type=script&lang=js"
import style0 from "./calls-list.vue?vue&type=style&index=0&id=bab962da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab962da",
  null
  
)

export default component.exports